import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Button } from 'react-admin'

import VpnKey from '@material-ui/icons/VpnKey'

import { toggleEditPasswordModal } from '../../../redux/actions/modals'
import EditPasswordModal from '../modals/EditPasswordModal'

const EditPasswordAction = props => (
  <Fragment>
    <Button
      label='Edit password'
      color='primary'
      onClick={props.toggleEditPasswordModal}
    >
      <VpnKey />
    </Button>
    <EditPasswordModal record={props.record} />
  </Fragment>
)

export default connect(null, {
  toggleEditPasswordModal
})(EditPasswordAction)
